import { generatePath, Navigate, Outlet } from "react-router-dom";
import { useSelectedOrganization } from "../../organizations/hooks";
import { AbsoluteRoute } from "../../../core/routes";

export const DashboardContainer = () => {
    // TODO: unify selected organization logic, reduce duplicated state
    const { hasAppManagementPermissions, selectedOrganizationId } = useSelectedOrganization();

    if (!hasAppManagementPermissions) {
        return (
            <Navigate
                to={generatePath(AbsoluteRoute.ORG_LENS_SCHEDULER_GROUPS, { orgId: selectedOrganizationId ?? "" })}
            />
        );
    }

    return (
        <div>
            <Outlet />
        </div>
    );
};
